import { useEffect, useState } from 'react';
import { copy } from '../content/copy';

export function FloatingDock() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="fixed right-4 md:right-6 bottom-20 md:bottom-24 z-40 flex flex-col gap-2">
      <a
        href={copy.contact.alt.telegram.href}
        target="_blank"
        rel="noreferrer noopener"
        aria-label="Telegram"
        className="w-11 h-11 rounded-full bg-l-paper-soft border border-l-rule shadow-sm flex items-center justify-center text-l-ink hover:text-l-terracotta hover:border-l-terracotta transition-colors"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M9.04 15.55 8.85 18.3c.27 0 .39-.12.54-.25l1.3-1.24 2.7 1.97c.5.27.85.13.98-.46l1.78-8.34.01-.01c.16-.74-.27-1.03-.75-.85L4.3 12.82c-.72.28-.71.68-.12.86l2.66.83 6.17-3.88c.29-.19.56-.09.34.1L9.04 15.55Z" />
        </svg>
      </a>
      <a
        href={copy.contact.alt.vk.href}
        target="_blank"
        rel="noreferrer noopener"
        aria-label="ВКонтакте"
        className="w-11 h-11 rounded-full bg-l-paper-soft border border-l-rule shadow-sm flex items-center justify-center text-l-ink hover:text-l-terracotta hover:border-l-terracotta transition-colors"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12.78 16.88c-4.87 0-7.65-3.36-7.77-8.94h2.44c.08 4.1 1.9 5.84 3.33 6.2V7.94h2.31v3.54c1.42-.15 2.9-1.76 3.4-3.54h2.31c-.38 2.19-1.99 3.8-3.14 4.46 1.15.54 3 1.94 3.69 4.48h-2.55c-.55-1.72-1.9-3.05-3.71-3.23v3.23h-.28Z"/>
        </svg>
      </a>
      <button
        type="button"
        onClick={scrollTop}
        aria-label="Наверх"
        className={`w-11 h-11 rounded-full bg-l-terracotta text-white shadow-ring-md flex items-center justify-center hover:bg-l-marginalia transition-all duration-200 ${
          showTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'
        }`}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M12 19V5M5 12l7-7 7 7" />
        </svg>
      </button>
    </div>
  );
}
